import React from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';
import { useLanguage } from '../contexts/LanguageContext';

const AboutPage = () => {
  const { t, isRTL } = useLanguage();

  return (
    <div className="landing-container" dir={isRTL ? 'rtl' : 'ltr'}>
      <header className="landing-header">
        <h1>{t('aboutSafaCards')}</h1>
        <p>{t('revolutionizingLanguageLearning')}</p>
      </header>

      <main className="landing-main" style={{ textAlign: isRTL ? 'right' : 'left', maxWidth: '800px', margin: '0 auto' }}>
        <section>
          <h2>{t('whyIBuiltSafaCards')}</h2>
          <p>{t('whyIBuiltDescription')}</p>
        </section>

        <section>
          <h2>{t('howSafaCardsGotName')}</h2>
          <p>{t('howSafaCardsGotNameDescription')}</p>
          <p>{t('howSafaCardsGotNameDescription2')}</p>
        </section>

        <section>
          <h2>{t('howItWorks')}</h2>
          <h3>{t('pickWhatYouWantToLearn')}</h3>
          <p>{t('pickWhatYouWantDescription')}</p>

          <h3>{t('smartReviewSystem')}</h3>
          <p>{t('smartReviewDescription')}</p>

          <h3>{t('learnWordsInContext')}</h3>
          <p>{t('learnWordsInContextDescription')}</p>

          <h3>{t('practiceWithConversations')}</h3>
          <p>{t('practiceWithConversationsDescription')}</p>
        </section>

        <section>
          <h2>{t('behindTheScenes')}</h2>
          <p>{t('behindTheScenesDescription')}</p>
          <ul>
            <li><strong>{t('reactNodejs')}</strong></li>
            <li><strong>{t('googleAI')}</strong></li>
            <li><strong>{t('spacedRepetition')}</strong></li>
            <li><strong>{t('realTimeUpdates')}</strong></li>
          </ul>
        </section>

        <section>
          <h2>{t('whatMakesSafaCardsDifferent')}</h2>
          <div className="features-grid" style={{ marginTop: '20px' }}>
            <div className="feature-card">
              <h4>{t('learnWhatYouNeed')}</h4>
              <p>{t('learnWhatYouNeedDescription')}</p>
            </div>
            <div className="feature-card">
              <h4>{t('scienceBasedLearning')}</h4>
              <p>{t('scienceBasedLearningDescription')}</p>
            </div>
            <div className="feature-card">
              <h4>{t('realConversations')}</h4>
              <p>{t('realConversationsDescription')}</p>
            </div>
            <div className="feature-card">
              <h4>{t('alwaysImproving')}</h4>
              <p>{t('alwaysImprovingDescription')}</p>
            </div>
          </div>
        </section>

        <section>
          <h2>{t('readyToStartLearning')}</h2>
          <p>{t('readyToStartDescription')}</p>
        </section>

        <div style={{ textAlign: 'center', marginTop: '40px' }}>
          <Link to="/home" className="btn btn-primary">{t('backToHome')}</Link>
        </div>
      </main>

      <footer className="landing-footer">
        <div className="footer-links">
          <Link to="/about">{t('about')}</Link>
          <Link to="/privacy">{t('privacyPolicy')}</Link>
          <Link to="/terms">{t('termsOfService')}</Link>
          <Link to="/support">{t('supportTitle') || 'Support'}</Link>
        </div>
        <p>&copy; {new Date().getFullYear()} SafaCards App. {t('allRightsReserved')}</p>
      </footer>
    </div>
  );
};

export default AboutPage; 